import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { VENDOR_CATEGORIES } from "./vendorUtils";

export function VendorFields({ form, setForm, prefix }) {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-1.5">
        <Label htmlFor={`${prefix}-name`}>Name *</Label>
        <Input id={`${prefix}-name`} value={form.name} onChange={set("name")} data-testid={`${prefix}-vendor-name`} />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${prefix}-website`}>Website</Label>
        <Input id={`${prefix}-website`} value={form.website} onChange={set("website")} placeholder="https://www.beispiel.de" data-testid={`${prefix}-vendor-website`} />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${prefix}-category`}>Kategorie</Label>
        <Input id={`${prefix}-category`} list={`${prefix}-category-list`} value={form.category} onChange={set("category")} placeholder="z. B. Praxisverwaltung (PVS)" data-testid={`${prefix}-vendor-category`} />
        <datalist id={`${prefix}-category-list`}>{VENDOR_CATEGORIES.map((c) => <option key={c} value={c} />)}</datalist>
      </div>
      <div className="space-y-1.5">
        <Label>Status</Label>
        <Select value={form.status} onValueChange={(v) => setForm((f) => ({ ...f, status: v }))}>
          <SelectTrigger data-testid={`${prefix}-vendor-status`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Aktiv</SelectItem>
            <SelectItem value="inactive">Inaktiv</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <Label htmlFor={`${prefix}-description`}>Beschreibung</Label>
        <Textarea id={`${prefix}-description`} rows={3} value={form.description} onChange={set("description")} data-testid={`${prefix}-vendor-description`} />
      </div>
    </div>
  );
}
